import apicaller from '../../../utils/apicaller';
import api from '../../../main.api';
import constant from '../../../main.constants';

let personDetailRequestSequence = 0;
let coPresenceRequestSequence = 0;

const actions = {
    async FETCH_JOB({ commit }, { jobId }) {
        if (!jobId) return null;
        commit('setCurrentJobLoading', true);
        try {
            const { data } = await apicaller.get(`${api.FACESEARCHJOB.getById}/${jobId}`);
            const job = data && data.result ? data.result : null;
            commit('setCurrentJob', job);
            return job;
        } catch (e) {
            console.log('FETCH_JOB error', e);
            return null;
        } finally {
            commit('setCurrentJobLoading', false);
        }
    },
    START_JOB_POLL({ commit, dispatch, state, getters }, { jobId }) {
        commit('clearPollHandle');
        commit('setCurrentJob', { id: jobId, status: constant.FACE_JOB_STATUS.PENDING, fileCount: 0, processedCount: 0 });
        dispatch('FETCH_JOB', { jobId });
        const handle = setInterval(async () => {
            await dispatch('FETCH_JOB', { jobId: state.currentJobId });
            if (getters.isJobTerminal) {
                commit('clearPollHandle');
            }
        }, constant.FACE_JOB_POLL_INTERVAL_MS);
        commit('setPollHandle', handle);
    },
    STOP_JOB_POLL({ commit }) {
        commit('clearPollHandle');
    },
    async FETCH_JOBS({ commit }, params) {
        commit('setJobsListLoading', true);
        try {
            const { data } = await apicaller.get(api.FACESEARCHJOB.mine, { params });
            const raw = data && data.result ? data.result : null;

            let items = [];
            let total = 0;

            if (raw) {
                items = raw.items || raw.jobs || [];

                if (typeof raw.total === 'number') {
                    total = raw.total;
                } else {
                    total = items.length;
                }
            }

            const result = { items, total };
            commit('setJobsList', result);
            return result;
        } catch (e) {
            console.log('FETCH_JOBS error', e);
            commit('setJobsList', { items: [], total: 0 });
            return { items: [], total: 0 };
        } finally {
            commit('setJobsListLoading', false);
        }
    },
    async UPLOAD_VIDEO({ commit, dispatch }, { formData }) {
        commit('setVideoUploadInFlight', true);
        try {
            const { data } = await apicaller.post(api.FACEVIDEOUPLOAD.upload, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            const result = data && data.result ? data.result : null;
            if (result && result.uploadId) {
                dispatch('START_VIDEO_POLL', { uploadId: result.uploadId });
            }
            return result;
        } catch (e) {
            console.log('UPLOAD_VIDEO error', e);
            return null;
        } finally {
            commit('setVideoUploadInFlight', false);
        }
    },
    async FETCH_VIDEO_UPLOAD({ commit }, { uploadId }) {
        if (!uploadId) return null;
        commit('setVideoCurrentUploadLoading', true);
        try {
            const { data } = await apicaller.get(`${api.FACEVIDEOUPLOAD.status}/${uploadId}/status`);
            const upload = data && data.result ? data.result : null;
            commit('setVideoCurrentUpload', upload);
            return upload;
        } catch (e) {
            console.log('FETCH_VIDEO_UPLOAD error', e);
            return null;
        } finally {
            commit('setVideoCurrentUploadLoading', false);
        }
    },
    START_VIDEO_POLL({ commit, dispatch, state, getters }, { uploadId }) {
        commit('clearVideoPollHandle');
        commit('setVideoCurrentUpload', {
            uploadId,
            status: constant.FACE_VIDEO_JOB_STATUS.PENDING,
            totalFrames: 0,
            processedFrames: 0,
            facesDetected: 0,
            facesMatched: 0,
            coPresenceEvents: 0,
            frames: []
        });
        dispatch('FETCH_VIDEO_UPLOAD', { uploadId });
        const handle = setInterval(async () => {
            await dispatch('FETCH_VIDEO_UPLOAD', { uploadId: state.videoCurrentUploadId });
            if (getters.isVideoJobTerminal) {
                commit('clearVideoPollHandle');
            }
        }, constant.FACE_VIDEO_POLL_INTERVAL_MS);
        commit('setVideoPollHandle', handle);
    },
    STOP_VIDEO_POLL({ commit }) {
        commit('clearVideoPollHandle');
    },
    // Video eslesmesindeki kimligin cozulmesi (upload id + sonuc id). Vuex COMMIT YAPMAZ:
    // cozulen TC devtools action/mutation log'una girmesin diye state'e hic yazilmaz,
    // yalniz cagirana doner. Sunucu her cagride ayri bir denetim satiri yazar.
    // analysisId ZORUNLUDUR: denetim satiri ona baglanir, aksi halde Log Kayitlari ekraninda
    // listelenmez (bkz. FaceVideoIdentityRevealRequestDTO.AnalysisId). Cagiran analiz yoksa
    // istegi hic baslatmaz, "yeni analiz" penceresini acar.
    RESOLVE_FACE_IDENTITIES(_ctx, { uploadId, resultId, analysisId }) {
        if ((!uploadId && uploadId !== 0) || !resultId || !analysisId) return Promise.resolve([]);
        return apicaller.post(`${api.FACEVIDEOUPLOAD.base}/${uploadId}/resolve-identity`, {
            resultId: String(resultId),
            analysisId: analysisId
        })
            .then(({ data }) => (data && data.result ? data.result.identityNumbers || [] : []))
            .catch(e => {
                // Ham hata nesnesi cozulmus TC'yi tasiyabilir; yalniz mesaj loglanir.
                console.log('RESOLVE_FACE_IDENTITIES error', e.message);
                return Promise.reject(e);
            });
    },
    // "Kisiyi Goster": kimlik numarasinin yani sira gizlenen alanlar (tam soyad, dogum tarihi)
    // de istenir. RESOLVE_FACE_IDENTITIES ile ayni uc, ayni denetim davranisi; fark yalniz
    // istenen alan kumesi ve donus bicimidir ({ resultId, identityNumber, soyad, dogumtarih }).
    // COMMIT YAPMAZ: cozulen deger state'e ve devtools log'una girmez, yalniz cagirana doner.
    RESOLVE_FACE_IDENTITY_DETAILS(_ctx, { uploadId, resultId, analysisId }) {
        if ((!uploadId && uploadId !== 0) || !resultId || !analysisId) return Promise.resolve(null);
        return apicaller.post(`${api.FACEVIDEOUPLOAD.base}/${uploadId}/resolve-identity`, {
            resultId: String(resultId),
            analysisId: analysisId,
            includeDetails: true
        })
            .then(({ data }) => {
                const identities = data && data.result ? data.result.identities || [] : [];
                return identities.length > 0 ? identities[0] : null;
            })
            .catch(e => {
                // Ham hata nesnesi cozulmus TC'yi tasiyabilir; yalniz mesaj loglanir.
                console.log('RESOLVE_FACE_IDENTITY_DETAILS error', e.message);
                return Promise.reject(e);
            });
    },
    // Kisi detay dialogu icin kayitli kaynak fotograflari; personDetail state'ine dokunmaz.
    FETCH_PERSON_SOURCE_PHOTOS(_ctx, { kimlikno, analysisId }) {
        if (!kimlikno || !analysisId) return Promise.resolve([]);
        return apicaller.get(`${api.FACEPERSON.base}/${kimlikno}`, { params: { analysisId } })
            .then(({ data }) => {
                const person = data && data.result ? data.result : null;
                return (person && person.source_photos) || [];
            })
            .catch(e => {
                console.log('FETCH_PERSON_SOURCE_PHOTOS error', e);
                return Promise.reject(e);
            });
    },
    // Manuel yukleme ekraninda TC girildiginde gosterilen kisi ozeti; personDetail state'ine
    // dokunmaz (kisi dosyasi ekrani ayni anda acik olabilir) ve HATA FIRLATMAZ: cagiran ekran
    // yetki/kayit durumunu ayirt edip mesaji kendisi secer. found=false "nufus kaydi yok" demek
    // DEGILDIR; bu uctan yalniz yuz havuzunda kaydi olan kisiler doner.
    FETCH_PERSON_SUMMARY(_ctx, { kimlikno, analysisId }) {
        if (!kimlikno || !analysisId) return Promise.resolve({ found: false, forbidden: false, error: true });
        return apicaller.get(`${api.FACEPERSON.base}/${kimlikno}`, { params: { analysisId } })
            .then(({ data }) => {
                const person = data && data.result ? data.result : null;
                const sourcePhotos = (person && person.source_photos) || [];
                const alarms = (person && person.alarms) || [];
                const firstPhoto = sourcePhotos[0] || {};
                return {
                    found: sourcePhotos.length > 0 || alarms.length > 0,
                    forbidden: false,
                    hasTwin: !!(person && person.has_twin),
                    photoCount: sourcePhotos.length,
                    alarmCount: alarms.length,
                    nufusIlce: firstPhoto.nufusIlce || '',
                    ikametIlce: firstPhoto.ikametIlce || '',
                    adres: firstPhoto.adres || '',
                    photos: sourcePhotos
                        .filter(photo => !!photo.image_base64)
                        .map(photo => ({
                            src: `data:image/jpeg;base64,${photo.image_base64}`,
                            kaynakkod: photo.kaynakkod
                        }))
                };
            })
            .catch(e => {
                console.log('FETCH_PERSON_SUMMARY error', e);
                const status = e && e.response ? e.response.status : null;
                return { found: false, forbidden: status === 403, error: true };
            });
    },
    // "Bu yuzle yeniden ara" — arama track'in sunucuda sakli embedding'i ile yapilir (tespit adimi yok).
    SEARCH_VIDEO_TRACK(_ctx, { uploadId, trackId, topK, threshold }) {
        if (!uploadId && uploadId !== 0) return Promise.resolve(null);
        const params = {};
        if (topK !== null && topK !== undefined) params.top_k = topK;
        if (threshold !== null && threshold !== undefined) params.threshold = threshold;
        return apicaller.post(`${api.FACEVIDEOUPLOAD.status}/${uploadId}/track/${trackId}/search`, null, { params })
            .then(({ data }) => (data && data.result ? data.result : null))
            .catch(e => {
                console.log('SEARCH_VIDEO_TRACK error', e);
                return null;
            });
    },
    async FETCH_VIDEO_UPLOADS({ commit }, params) {
        commit('setVideoUploadsListLoading', true);
        try {
            const { data } = await apicaller.get(api.FACEVIDEOUPLOAD.mine, { params });
            const raw = data && data.result ? data.result : null;

            let items = [];
            let total = 0;

            if (raw) {
                items = raw.items || raw.uploads || [];

                if (typeof raw.total === 'number') {
                    total = raw.total;
                } else {
                    total = items.length;
                }
            }

            const result = { items, total };
            commit('setVideoUploadsList', result);
            return result;
        } catch (e) {
            console.log('FETCH_VIDEO_UPLOADS error', e);
            commit('setVideoUploadsList', { items: [], total: 0 });
            return { items: [], total: 0 };
        } finally {
            commit('setVideoUploadsListLoading', false);
        }
    },

    FETCH_SCENARIOS({ commit }, payload = {}) {
        // silent=true -> progress poll'unda loading state'i toggle etme (tablo flicker'ini onle).
        const silent = payload && payload.silent;
        if (!silent) commit('setScenariosListLoading', true);
        return apicaller.get(api.FACESCENARIO.system)
            .then(({ data }) => {
                const items = data && data.result ? data.result : [];
                commit('setScenariosList', items);
                return items;
            })
            .catch(e => {
                console.log('FETCH_SCENARIOS error', e);
                if (!silent) commit('setScenariosList', []);
                return [];
            })
            .finally(() => {
                if (!silent) commit('setScenariosListLoading', false);
            });
    },
    FETCH_SCENARIO_RUNS(_ctx, { scenarioId, limit = 50 }) {
        return apicaller.get(`${api.FACESCENARIO.base}/${scenarioId}/runs`, { params: { limit } })
            .then(({ data }) => (data && data.result ? data.result : []))
            .catch(e => {
                console.log('FETCH_SCENARIO_RUNS error', e);
                return [];
            });
    },
    UPDATE_SCENARIO_PARAMS(_ctx, { scenarioId, payload }) {
        return apicaller.put(`${api.FACESCENARIO.base}/${scenarioId}`, payload)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message, result: data && data.result }))
            .catch(e => {
                console.log('UPDATE_SCENARIO_PARAMS error', e);
                return { ok: false, message: null };
            });
    },
    SET_SCENARIO_ACTIVE(_ctx, { scenarioId, isActive }) {
        const verb = isActive ? 'activate' : 'deactivate';
        return apicaller.post(`${api.FACESCENARIO.base}/${scenarioId}/${verb}`)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message }))
            .catch(e => {
                console.log('SET_SCENARIO_ACTIVE error', e);
                return { ok: false, message: null };
            });
    },
    RUN_SCENARIO(_ctx, { scenarioId }) {
        return apicaller.post(`${api.FACESCENARIO.base}/${scenarioId}/run`)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message, result: data && data.result }))
            .catch(e => {
                console.log('RUN_SCENARIO error', e);
                return { ok: false, message: null };
            });
    },
    RUN_INITIAL_TC_SCAN() {
        return apicaller.post(api.FACEADMIN.runInitialTcScan)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message, result: data && data.result }))
            .catch(e => {
                console.log('RUN_INITIAL_TC_SCAN error', e);
                return { ok: false, message: null };
            });
    },
    //  aylik force re-scan guvenlik agi — imleci 0'a cek + mode=full drain (arka plan, aninda doner).
    RUN_FORCE_RESCAN() {
        return apicaller.post(api.FACEADMIN.runForceRescan)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message, result: data && data.result }))
            .catch(e => {
                console.log('RUN_FORCE_RESCAN error', e);
                return { ok: false, message: null };
            });
    },
    FETCH_ALARMS({ commit }, params) {
        commit('setAlarmsListLoading', true);
        return apicaller.get(api.FACEALARM.list, { params })
            .then(({ data }) => {
                const raw = data && data.result ? data.result : null;
                let items = [];
                let total = 0;
                if (raw) {
                    items = Array.isArray(raw) ? raw : (raw.items || []);
                    total = typeof raw.total === "number" ? raw.total : items.length;
                }
                const result = { items, total };
                commit('setAlarmsList', result);
                return result;
            })
            .catch(e => {
                console.log('FETCH_ALARMS error', e);
                commit('setAlarmsList', { items: [], total: 0 });
                return { items: [], total: 0 };
            })
            .finally(() => {
                commit('setAlarmsListLoading', false);
            });
    },
    // Kanit fotograflari: alarm kimlikno'lari -> sahisresim (arama sayfasi deseni; milvus_id kullanilmaz).
    // Drawer acilinca lazy cagrilir; state'e yazilmaz, bilesen-lokal tutulur (FETCH_SCENARIO_RUNS deseni).
    FETCH_ALARM_PHOTOS(_ctx, { alarmId }) {
        return apicaller.get(`${api.FACEALARM.base}/${alarmId}/photos`)
            .then(({ data }) => (data && data.result ? data.result : null))
            .catch(e => {
                console.log('FETCH_ALARM_PHOTOS error', e);
                return null;
            });
    },
    CONFIRM_ALARM(_ctx, { alarmId, reason }) {
        return apicaller.post(`${api.FACEALARM.base}/${alarmId}/confirm`, { reason })
            .then(({ data }) => ({ ok: data && data.statusCode === 200, statusCode: data && data.statusCode, message: data && data.message }))
            .catch(e => {
                console.log('CONFIRM_ALARM error', e);
                return { ok: false, message: null };
            });
    },
    DISMISS_ALARM(_ctx, { alarmId, reason }) {
        return apicaller.post(`${api.FACEALARM.base}/${alarmId}/dismiss`, { reason })
            .then(({ data }) => ({ ok: data && data.statusCode === 200, statusCode: data && data.statusCode, message: data && data.message }))
            .catch(e => {
                console.log('DISMISS_ALARM error', e);
                return { ok: false, message: null };
            });
    },
    // Fotograf kaynak kodu -> aciklama lookup'u. Tablo minik ve statik oldugu icin
    // oturum basina bir kez cekilir; ekranlar created() icinde kosulsuz dispatch edebilir.
    FETCH_PHOTO_SOURCES({ commit, state }) {
        if (state.photoSourcesLoaded || state.photoSourcesLoading) {
            return Promise.resolve(state.photoSources);
        }
        commit('setPhotoSourcesLoading', true);
        return apicaller.get(api.FACEPHOTOSOURCE.list)
            .then(({ data }) => {
                const items = data && data.result ? data.result : [];
                commit('setPhotoSources', items);
                return items;
            })
            .catch(e => {
                console.log('FETCH_PHOTO_SOURCES error', e);
                commit('setPhotoSources', []);
                return [];
            })
            .finally(() => {
                commit('setPhotoSourcesLoading', false);
            });
    },
    FETCH_SYSTEM_CONFIG({ commit }) {
        commit('setSystemConfigLoading', true);
        return apicaller.get(api.FACESYSTEMCONFIG.get)
            .then(({ data }) => {
                const items = data && data.result ? data.result : [];
                commit('setSystemConfig', items);
                return items;
            })
            .catch(e => {
                console.log('FETCH_SYSTEM_CONFIG error', e);
                commit('setSystemConfig', []);
                return [];
            })
            .finally(() => {
                commit('setSystemConfigLoading', false);
            });
    },
    UPDATE_SYSTEM_CONFIG(_ctx, { configKey, value }) {
        return apicaller.put(`${api.FACESYSTEMCONFIG.base}/${configKey}`, { value })
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message }))
            .catch(e => {
                console.log('UPDATE_SYSTEM_CONFIG error', e);
                return { ok: false, message: null };
            });
    },
    FETCH_EXCLUSIONS({ commit }, params) {
        commit('setExclusionsListLoading', true);
        return apicaller.get(api.FACEMATCHFEEDBACK.exclusion, { params })
            .then(({ data }) => {
                const items = data && data.result ? data.result : [];
                commit('setExclusionsList', items);
                return items;
            })
            .catch(e => {
                console.log('FETCH_EXCLUSIONS error', e);
                commit('setExclusionsList', []);
                return [];
            })
            .finally(() => {
                commit('setExclusionsListLoading', false);
            });
    },
    // analysisId ZORUNLUDUR: kisi dosyasi kimlik + foto + adres dondurur, sunucu her cagride denetim
    // satiri yazar ve o satir analize baglanmazsa Log Kayitlari ekraninda hic listelenmez
    // (bkz. FacePersonService.ValidateAnalysisReference). Analiz yoksa istek hic baslatilmaz.
    CLEAR_PERSON_DETAIL({ commit }) {
        personDetailRequestSequence += 1;
        commit('setPersonDetail', null);
        commit('setPersonDetailError', false);
        commit('setPersonDetailLoading', false);
        commit('setPersonMatchHistory', []);
    },
    FETCH_PERSON_DETAIL({ commit }, { kimlikno, analysisId }) {
        if (!kimlikno || !analysisId) return Promise.resolve(null);
        const requestId = ++personDetailRequestSequence;
        commit('setPersonDetail', null);
        commit('setPersonDetailError', false);
        commit('setPersonDetailLoading', true);
        return apicaller.get(`${api.FACEPERSON.base}/${kimlikno}`, { params: { analysisId } })
            .then(({ data }) => {
                const person = data && data.result ? data.result : null;
                if (requestId !== personDetailRequestSequence) return null;
                commit('setPersonDetail', person);
                return person;
            })
            .catch(e => {
                console.log('FETCH_PERSON_DETAIL error', e);
                if (requestId === personDetailRequestSequence) {
                    commit('setPersonDetail', null);
                    commit('setPersonDetailError', true);
                }
                return null;
            })
            .finally(() => {
                if (requestId === personDetailRequestSequence) commit('setPersonDetailLoading', false);
            });
    },
    FETCH_PERSON_MATCH_HISTORY({ commit }, { kimlikno, analysisId, limit = 50, offset = 0 }) {
        if (!kimlikno || !analysisId) return Promise.resolve({ items: [], total: 0 });
        commit('setPersonMatchHistoryLoading', true);
        return apicaller.get(`${api.FACEPERSON.base}/${kimlikno}/match-history`, { params: { analysisId, limit, offset } })
            .then(({ data }) => {
                const raw = data && data.result ? data.result : null;
                const items = raw ? (raw.items || []) : [];
                if (offset === 0) commit('setPersonMatchHistory', items);
                return { items, total: raw && typeof raw.total === 'number' ? raw.total : items.length };
            })
            .catch(e => {
                console.log('FETCH_PERSON_MATCH_HISTORY error', e);
                return { items: [], total: 0 };
            })
            .finally(() => {
                commit('setPersonMatchHistoryLoading', false);
            });
    },
    // Birliktelik (timeline + iliski agi) — mevcut GET /FaceCoPresence/kimlikno/{kimlikno} reuse.
    // analysisId ZORUNLUDUR: VIP elemesi ve denetim izi (sysaudit + vipauditlog) sunucuda bu ucun
    // ICINDE yazilir (bkz. FaceCoPresenceService.GetByKimlikno); analize baglanmayan satir
    // Log Kayitlari ekraninda listelenmez. Analiz yoksa istek hic baslatilmaz.
    FETCH_CO_PRESENCE({ commit }, { kimlikno, analysisId, limit = 50, offset = 0 }) {
        if (!kimlikno || !analysisId) return Promise.resolve(null);
        const requestId = ++coPresenceRequestSequence;
        if (offset === 0) {
            commit('setCoPresence', null);
            commit('setCoPresenceKimlikno', kimlikno);
            commit('setCoPresenceError', false);
        }
        commit('setCoPresenceLoading', true);
        return apicaller.get(`${api.FACECOPRESENCE.base}/kimlikno/${kimlikno}`, { params: { analysisId, limit, offset } })
            .then(({ data }) => {
                const result = data && data.result ? data.result : null;
                if (requestId === coPresenceRequestSequence) {
                    commit('setCoPresence', result);
                    commit('setCoPresenceKimlikno', kimlikno);
                }
                return result;
            })
            .catch(e => {
                console.log('FETCH_CO_PRESENCE error', e);
                if (requestId === coPresenceRequestSequence) {
                    commit('setCoPresence', null);
                    commit('setCoPresenceError', true);
                }
                return null;
            })
            .finally(() => {
                if (requestId === coPresenceRequestSequence) commit('setCoPresenceLoading', false);
            });
    },
    DELETE_EXCLUSION(_ctx, { id }) {
        return apicaller.delete(`${api.FACEMATCHFEEDBACK.exclusion}/${id}`)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message }))
            .catch(e => {
                console.log('DELETE_EXCLUSION error', e);
                return { ok: false, message: null };
            });
    },
    FETCH_IDENTITY_CLUSTERS({ commit }, params) {
        commit('setIdentityClustersListLoading', true);
        return apicaller.get(api.FACEIDENTITYCLUSTER.clusters, { params })
            .then(({ data }) => {
                const raw = data && data.result ? data.result : null;
                const items = raw ? (raw.clusters || []) : [];
                const total = raw && typeof raw.total === 'number' ? raw.total : items.length;
                const result = { items, total };
                commit('setIdentityClustersList', result);
                return result;
            })
            .catch(e => {
                console.log('FETCH_IDENTITY_CLUSTERS error', e);
                commit('setIdentityClustersList', { items: [], total: 0 });
                return { items: [], total: 0 };
            })
            .finally(() => {
                commit('setIdentityClustersListLoading', false);
            });
    },
    FETCH_IDENTITY_CLUSTER({ commit }, { clusterId }) {
        if (!clusterId) return Promise.resolve(null);
        commit('setClusterDetailLoading', true);
        return apicaller.get(`${api.FACEIDENTITYCLUSTER.clusters}/${clusterId}`)
            .then(({ data }) => {
                const cluster = data && data.result ? data.result : null;
                commit('setClusterDetail', cluster);
                return cluster;
            })
            .catch(e => {
                console.log('FETCH_IDENTITY_CLUSTER error', e);
                commit('setClusterDetail', null);
                return null;
            })
            .finally(() => {
                commit('setClusterDetailLoading', false);
            });
    },
    // Faz 5 kisi dosyasi kume sekmesi — bir kimlikno'yu iceren supheli kume(ler).
    FETCH_IDENTITY_CLUSTERS_BY_KIMLIKNO(_ctx, { kimlikno }) {
        if (!kimlikno) return Promise.resolve([]);
        return apicaller.get(`${api.FACEIDENTITYCLUSTER.byKimlikno}/${kimlikno}`)
            .then(({ data }) => {
                const raw = data && data.result ? data.result : null;
                return raw ? (raw.clusters || []) : [];
            })
            .catch(e => {
                console.log('FETCH_IDENTITY_CLUSTERS_BY_KIMLIKNO error', e);
                return [];
            });
    },
    FETCH_IDENTITY_SCAN_STATUS({ commit }, payload = {}) {
        const silent = payload && payload.silent;
        if (!silent) commit('setIdentityScanStatusLoading', true);
        return apicaller.get(api.FACEIDENTITYCLUSTER.scanStatus)
            .then(({ data }) => {
                const status = data && data.result ? data.result : null;
                commit('setIdentityScanStatus', status);
                return status;
            })
            .catch(e => {
                console.log('FETCH_IDENTITY_SCAN_STATUS error', e);
                return null;
            })
            .finally(() => {
                if (!silent) commit('setIdentityScanStatusLoading', false);
            });
    },
    RUN_INITIAL_IDENTITY_SCAN() {
        return apicaller.post(api.FACEADMIN.runInitialIdentityScan)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message, result: data && data.result }))
            .catch(e => {
                console.log('RUN_INITIAL_IDENTITY_SCAN error', e);
                return { ok: false, message: null };
            });
    },
    // pause | resume | stop (FaceAdmin). action = endpoint suffix.
    IDENTITY_SCAN_CONTROL(_ctx, { action }) {
        return apicaller.post(`${api.FACEIDENTITYCLUSTER.scanControl}/${action}`)
            .then(({ data }) => ({ ok: data && data.statusCode === 200, message: data && data.message, result: data && data.result }))
            .catch(e => {
                console.log('IDENTITY_SCAN_CONTROL error', e);
                return { ok: false, message: null };
            });
    }
};

export default actions;
